<template>
  <div class="activity-management">
    <el-card class="search-card">
      <div slot="header" class="clearfix">
        <el-button type="primary" @click="handleAdd" icon="el-icon-plus">新增活动</el-button>
      </div>

      <el-table :data="tableData" border stripe v-loading="tableLoading" height="calc(100vh - 280px)">
        <el-table-column prop="id" label="ID" width="80"></el-table-column>
        <el-table-column prop="name" label="活动名称" min-width="150"></el-table-column>
        <el-table-column label="轮播图" width="120">
          <template slot-scope="scope">
            <el-image
              v-if="scope.row.imageUrl"
              :src="scope.row.imageUrl"
              style="width: 80px; height: 60px"
              fit="cover"
              :preview-src-list="[scope.row.imageUrl]"
            ></el-image>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="详情图" width="120">
          <template slot-scope="scope">
            <el-image
              v-if="scope.row.detailImageUrl"
              :src="scope.row.detailImageUrl"
              style="width: 80px; height: 60px"
              fit="cover"
              :preview-src-list="[scope.row.detailImageUrl]"
            ></el-image>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="sort" label="排序" width="80"></el-table-column>
        <el-table-column prop="status" label="状态" width="80">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === 1 ? 'success' : 'info'" size="small">
              {{ scope.row.status === 1 ? '启用' : '禁用' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" width="220">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="handleEdit(scope.row)">编辑</el-button>
            <el-button type="text" size="small" @click="handleStatus(scope.row)">
              {{ scope.row.status === 1 ? '禁用' : '启用' }}
            </el-button>
            <el-button type="text" size="small" @click="handleDelete(scope.row)" style="color: #F56C6C;">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handlePageChange"
        :current-page="pagination.pageNum"
        :page-sizes="[10, 20, 50]"
        :page-size="pagination.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.total"
        style="margin-top: 20px; text-align: right;">
      </el-pagination>
    </el-card>

    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="650px" @close="handleDialogClose">
      <el-form :model="form" :rules="rules" ref="form" label-width="100px">
        <el-form-item label="活动名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入活动名称"></el-input>
        </el-form-item>

        <el-form-item label="轮播图" prop="imageUrl">
          <div class="upload-wrap">
            <el-upload
              class="activity-uploader"
              :action="uploadUrl"
              :headers="uploadHeaders"
              :data="{ type: 'swiper' }"
              :show-file-list="false"
              :before-upload="(file) => beforeAvatarUpload(file, 'swiper')"
              :on-success="(res, file) => handleSwiperSuccess(res, file)"
              :on-error="handleUploadError"
              accept="image/*"
            >
              <img v-if="form.imageUrl" :src="form.imageUrl" class="uploaded-img" />
              <i v-else class="el-icon-plus uploader-icon"></i>
            </el-upload>
            <div class="upload-tip">
              <span v-if="uploading.swiper" class="uploading-text">上传中...</span>
              <span v-else-if="!form.imageUrl" class="hint-text">点击上传轮播图</span>
              <el-button v-else type="text" size="small" @click="handlePreview(form.imageUrl)">预览大图</el-button>
            </div>
          </div>
        </el-form-item>

        <el-form-item label="详情图" prop="detailImageUrl">
          <div class="upload-wrap">
            <el-upload
              class="activity-uploader"
              :action="uploadUrl"
              :headers="uploadHeaders"
              :data="{ type: 'detail' }"
              :show-file-list="false"
              :before-upload="(file) => beforeAvatarUpload(file, 'detail')"
              :on-success="(res, file) => handleDetailSuccess(res, file)"
              :on-error="handleUploadError"
              accept="image/*"
            >
              <img v-if="form.detailImageUrl" :src="form.detailImageUrl" class="uploaded-img" />
              <i v-else class="el-icon-plus uploader-icon"></i>
            </el-upload>
            <div class="upload-tip">
              <span v-if="uploading.detail" class="uploading-text">上传中...</span>
              <span v-else-if="!form.detailImageUrl" class="hint-text">点击上传详情图</span>
              <el-button v-else type="text" size="small" @click="handlePreview(form.detailImageUrl)">预览大图</el-button>
            </div>
          </div>
        </el-form-item>

        <el-form-item label="排序" prop="sort">
          <el-input-number v-model="form.sort" :min="0" :max="999"></el-input-number>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-radio-group v-model="form.status">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleSubmit" :loading="submitLoading">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="图片预览" :visible.sync="previewVisible" width="60%" append-to-body>
      <img :src="previewUrl" style="max-width: 100%; display: block; margin: 0 auto;" />
    </el-dialog>
  </div>
</template>

<script>
import { getActivityList, addActivity, updateActivity, deleteActivity, updateActivityStatus, uploadActivityImage } from '@/api'

export default {
  name: 'ActivityManagement',
  data() {
    return {
      tableData: [],
      tableLoading: false,
      pagination: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      dialogVisible: false,
      dialogTitle: '',
      previewVisible: false,
      previewUrl: '',
      submitLoading: false,
      uploading: {
        swiper: false,
        detail: false
      },
      form: {
        id: null,
        name: '',
        imageUrl: '',
        detailImageUrl: '',
        sort: 0,
        status: 1
      },
      rules: {
        name: [
          { required: true, message: '请输入活动名称', trigger: 'blur' }
        ],
        imageUrl: [
          { required: true, message: '请上传轮播图', trigger: 'change' }
        ]
      }
    }
  },
  computed: {
    uploadUrl() {
      const baseURL = process.env.VUE_APP_BASE_API || window.location.origin
      return baseURL + '/api/admin/upload/activity'
    },
    uploadHeaders() {
      const token = localStorage.getItem('token')
      return {
        Authorization: token ? `Bearer ${token}` : ''
      }
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    async loadData() {
      this.tableLoading = true
      try {
        const res = await getActivityList({
          pageNum: this.pagination.pageNum,
          pageSize: this.pagination.pageSize
        })
        this.tableData = res.data?.records || res.data || []
        this.pagination.total = res.data?.total || 0
      } catch (e) {
        console.error(e)
        this.$message.error('加载失败')
      } finally {
        this.tableLoading = false
      }
    },

    handlePageChange(page) {
      this.pagination.pageNum = page
      this.loadData()
    },

    handleSizeChange(size) {
      this.pagination.pageSize = size
      this.pagination.pageNum = 1
      this.loadData()
    },

    handleAdd() {
      this.dialogTitle = '新增活动'
      this.form = {
        id: null,
        name: '',
        imageUrl: '',
        detailImageUrl: '',
        sort: 0,
        status: 1
      }
      this.dialogVisible = true
    },
    handleEdit(row) {
      this.dialogTitle = '编辑活动'
      this.form = {
        id: row.id,
        name: row.name || '',
        imageUrl: row.imageUrl || '',
        detailImageUrl: row.detailImageUrl || '',
        sort: row.sort || 0,
        status: row.status
      }
      this.dialogVisible = true
    },
    handleDialogClose() {
      this.$refs.form.resetFields()
    },
    beforeAvatarUpload(file, type) {
      const isImage = file.type.startsWith('image/')
      const isLt10M = file.size / 1024 / 1024 < 10

      if (!isImage) {
        this.$message.error('只能上传图片文件')
        return false
      }
      if (!isLt10M) {
        this.$message.error('图片大小不能超过 10MB')
        return false
      }

      this.uploading[type] = true
      return true
    },
    async handleSwiperSuccess(res, file) {
      this.uploading.swiper = false
      if (res.code === 200 && res.data && res.data.url) {
        this.form.imageUrl = res.data.url
        this.$message.success('轮播图上传成功')
      } else {
        this.$message.error(res.message || '轮播图上传失败')
      }
    },
    async handleDetailSuccess(res, file) {
      this.uploading.detail = false
      if (res.code === 200 && res.data && res.data.url) {
        this.form.detailImageUrl = res.data.url
        this.$message.success('详情图上传成功')
      } else {
        this.$message.error(res.message || '详情图上传失败')
      }
    },
    handleUploadError(err) {
      this.uploading.swiper = false
      this.uploading.detail = false
      console.error(err)
      this.$message.error('上传失败，请重试')
    },
    handlePreview(url) {
      this.previewUrl = url
      this.previewVisible = true
    },
    handleSubmit() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.submitLoading = true
          try {
            const data = { ...this.form }
            if (this.form.id) {
              await updateActivity(this.form.id, data)
              this.$message.success('更新成功')
            } else {
              await addActivity(data)
              this.$message.success('添加成功')
            }
            this.dialogVisible = false
            this.loadData()
          } catch (e) {
            console.error(e)
            this.$message.error('操作失败')
          } finally {
            this.submitLoading = false
          }
        }
      })
    },
    async handleStatus(row) {
      const newStatus = row.status === 1 ? 0 : 1
      const text = newStatus === 1 ? '启用' : '禁用'
      try {
        await this.$confirm(`确定要${text}该活动吗？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        await updateActivityStatus(row.id, newStatus)
        this.$message.success(`${text}成功`)
        this.loadData()
      } catch (e) {
        if (e !== 'cancel') {
          console.error(e)
        }
      }
    },
    async handleDelete(row) {
      try {
        await this.$confirm('确定要删除该活动吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        await deleteActivity(row.id)
        this.$message.success('删除成功')
        this.loadData()
      } catch (e) {
        if (e !== 'cancel') {
          console.error(e)
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
.activity-management {
  padding: 20px;
}

.search-card {
  margin-bottom: 20px;
}

.upload-wrap {
  display: flex;
  align-items: flex-start;
  gap: 15px;
}

.activity-uploader {
  ::v-deep .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    transition: border-color 0.2s;

    &:hover {
      border-color: #FF8C00;
    }
  }

  .uploaded-img {
    width: 148px;
    height: 148px;
    object-fit: cover;
    display: block;
  }

  .uploader-icon {
    width: 148px;
    height: 148px;
    line-height: 148px;
    text-align: center;
    font-size: 28px;
    color: #8c939d;
  }
}

.upload-tip {
  padding-top: 80px;

  .uploading-text {
    color: #FF8C00;
  }

  .hint-text {
    color: #999;
    font-size: 12px;
  }
}
</style>
